import React, { useEffect, useState, useMemo } from 'react';
import Table from '@awp/components/table';
import PropTypes from 'prop-types';
import CodeTabelService from './CodeTabelService';
import { CodeTableRow, CodeTableViewerProps } from '../Interfaces/CodeTableInterfaces';

const CodeTableViewer: React.FC<CodeTableViewerProps> = ({ observationTypeId, initialData, codeTableService }) => {
  const [codeTableData, setCodeTableData] = useState<CodeTableRow[] | null>([]);

  useEffect(() => {
    setCodeTableData(initialData);
  }, [initialData]);

  const columns = useMemo(() => {
    return codeTableService.getColumns({ mode: 'viewer' });
  }, [codeTableService]);

  if (!observationTypeId || codeTableData?.length === 0) {
    return <></>;
  }

  return (
    <Table
      columns={columns}
      data={codeTableData ?? []}
      {...codeTableService.defaultTableProps}
      defaultSortBy="ObservedCharacterValue"
      customClass={'simplebar-code-table'}
    />
  );
};

CodeTableViewer.propTypes = {
  observationTypeId: PropTypes.number.isRequired,
  initialData: PropTypes.array.isRequired,
  codeTableService: PropTypes.instanceOf(CodeTabelService).isRequired,
};

export default CodeTableViewer;
